import React from 'react';
import PropTypes from 'prop-types';
import DisconnectedRoleSelector from './disconnected';
import ConnectedRoleSelector from './connected';

import './roleSelector.css';

class RoleSelector extends React.Component {
    render() {
        return this.props.connected ? <ConnectedRoleSelector /> : <DisconnectedRoleSelector />;
    }
}

RoleSelector.defaultProps = {
    connected: undefined
};

RoleSelector.propTypes = {
    connected: PropTypes.bool.isRequired
};

export default RoleSelector;



// WEBPACK FOOTER //
// ./src/components/roleSelector/index.jsx